import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useNotification } from '../../../../../hooks'
import { getDocFlowRequestsPayload } from '../../../../../utils/docFlow'
import { ConfirmationModal } from '../../../../Confirmation'
import { disconnectDocFlowRequests } from '../../../DocFlow.api'
import { DocFlowProfileHeaderInfoItemsFields } from '../../../DocFlow.constants'
import {
  useDocFlowConnectRequests,
  useDocFlowContext,
} from '../../../DocFlow.hooks'

export function useDocFlowProfileHeaderConnectedRequests() {
  const { t } = useTranslation()

  const { docFlow, handleCloseModal, handleReloadDocFlow, setModal } =
    useDocFlowContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { handleOpenDocFlowConnectRequests } = useDocFlowConnectRequests({
    onCloseModal: handleCloseModal,
    onReload: handleReloadDocFlow,
    onSetModal: setModal,
  })

  function handleOpenConnectRequestsModal() {
    handleOpenDocFlowConnectRequests({
      connectedRequests:
        docFlow?.[DocFlowProfileHeaderInfoItemsFields.ConnectedRequests] ??
        EMPTY_LIST,
      docFlowId: docFlow.id,
    })
  }

  function handleRemoveConnectedRequest(requestId) {
    function handleSubmitDisconnect() {
      handleCloseModal()

      disconnectDocFlowRequests({
        data: getDocFlowRequestsPayload([requestId]),
        id: docFlow.id,
      })
        .then(() => {
          handleReloadDocFlow().finally(() => {
            handleAddSuccessNotification(
              'Notification.DocFlowsTitleDisconnectRequestKey'
            )
          })
        })
        .catch(() => {
          handleAddErrorNotification('Error.CommonApiRequestFailKey')
        })
    }

    setModal(
      <ConfirmationModal
        actionButtonsProps={{
          submitText: t('Modal.DisconnectRequestFromDocFlowBtnKey'),
        }}
        description={t('Modal.DisconnectRequestFromDocFlowAttentionMessageKey')}
        title={t('Modal.DisconnectRequestFromDocFlowTitleKey')}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitDisconnect}
      />
    )
  }

  return { handleOpenConnectRequestsModal, handleRemoveConnectedRequest }
}
